/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/use-memo */
import { DependencyList, RefObject, useCallback, useEffect } from "react";

export const useClick = (callback, deps?: DependencyList) =>
  useCallback((e, ...args) => {
    e.preventDefault();
    e.stopPropagation();
    return callback(e, ...args);
  }, deps || []);

// Roept `onOutside` aan bij een muisklik buiten alle `refs`, zolang `active`
// waar is: zo sluit een menu of popover wanneer je ernaast klikt. Geef ook het
// element mee dat hem opent, anders sluit en opent dezelfde klik hem meteen.
export const useOutsideClick = (
  refs: RefObject<HTMLElement | null>[],
  onOutside: () => void,
  active = true
) =>
  useEffect(() => {
    if (!active) return;
    const handler = (e: MouseEvent) => {
      const target = e.target as Node;
      if (refs.some((ref) => ref.current?.contains(target))) return;
      onOutside();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [active, onOutside, ...refs]);
